import { useState, useEffect } from "react";
import axiosInstance from "../api/axiosInstance";
import { ENDPOINTS } from "../api/endpoints";

export const useOrderTracking = (taskId) => {
  const [orderDetails, setOrderDetails] = useState(null);
  const [products, setProducts] = useState([]);
  const [pricing, setPricing] = useState({
    subTotal: 0,
    cgst: 0,
    sgst: 0,
    total: 0,
    paymentMode: "",
  });

  const fetchRestaurantDetails = async () => {
    const res = await axiosInstance.post(
      ENDPOINTS.RESTAURANT_DETAILS,
      { taskId }
    );

    if (res?.data?.responseCode === "00") {
      setOrderDetails(res.data.data);
    }
  };

  const fetchOrderItems = async () => {
    const res = await axiosInstance.post(
      ENDPOINTS.ORDER_ITEMS,
      { taskId }
    );

    const orders = res.data.data || [];
    const order = orders.find(o => String(o.task_id) === String(taskId));
    if (!order) return;

    setPricing({
      subTotal: Number(order.sub_total || 0),
      cgst: Number(order.cgst || 0),
      sgst: Number(order.sgst || 0),
      total: Number(order.total || 0),
      paymentMode: order.payment_mode || "Online",
    });

    setProducts(
      order.order_details?.items?.map((item, i) => ({
        id: i,
        name: item.itemName,
        qty: item.quantity,
        unitPrice: item.unitPrice,
        itemTotal: item.total,
        image: item.image,
      })) || []
    );
  };

  useEffect(() => {
    if (!taskId) return;
    fetchRestaurantDetails();
  }, [taskId]);

  return {
    orderDetails,
    products,
    pricing,
    fetchOrderItems,
  };
};
